import DGUtility from "../Model/DGUtility.m"

export type StyleModel = {
    container: object,
    light: object,
    dark: object,
}

export class EMETL404 extends DGUtility {
    /*** Private Members ***/
    
    // Define your view's data model using private members here...
    
    /*** Protected Members ***/
    
    /*** Private Methods ***/
    
    /*** Protected Methods ***/
    
    /**
     * Initialize and perform setup for the class
     */
    protected _init = () => {
        // Initialize or set all members based on constructor argument values 
        // Perform additional setup here...
    }
    
    /*** Public Methods ***/
    
    /**
     * Class constructor. Calls _init() on the superclass. Add parameters as needed
     */
    public constructor() {
        super()
        this._init()
    }
    
    // Define public methods (including accessors and mutators) here...
    
}

// Instantiate the VM and export the instance
const EMETL404VM = new EMETL404()

export default EMETL404VM
